function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#EDAA0C",
  fillOpacity: 0.1
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 4,
  y: 4,
  width: 24,
  height: 24,
  rx: 12,
  fill: "#EDAA0C"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.9925 20.2865V19.9607H12.6667C11.7407 19.9607 10.9944 19.6535 10.4804 19.1395C9.96641 18.6255 9.65917 17.8792 9.65917 16.9532V12.9532C9.65917 12.0272 9.96641 11.2809 10.4804 10.7669C10.9944 10.2529 11.7407 9.94567 12.6667 9.94567H19.3334C20.2593 9.94567 21.0057 10.2529 21.5197 10.7669C22.0337 11.2809 22.3409 12.0272 22.3409 12.9532V16.9532C22.3409 17.8792 22.0337 18.6255 21.5197 19.1395C21.0057 19.6535 20.2593 19.9607 19.3334 19.9607H16.6667H16.5682L16.4863 20.0153L13.5196 21.9886L13.5196 21.9886L13.5165 21.9907C13.2978 22.1398 12.9925 21.9842 12.9925 21.7065V20.2865ZM17.0208 15.2376L17.0208 15.2376L17.0228 15.2363L17.0291 15.232C17.2439 15.0866 17.9325 14.6204 17.9325 13.6865C17.9325 12.6199 17.0666 11.7541 16 11.7541C14.9334 11.7541 14.0676 12.6199 14.0676 13.6865C14.0676 14.1398 14.4401 14.5123 14.8934 14.5123C15.3466 14.5123 15.7192 14.1398 15.7192 13.6865C15.7192 13.5331 15.8466 13.4057 16 13.4057C16.1534 13.4057 16.2809 13.5331 16.2809 13.6865C16.2809 13.7044 16.2789 13.7114 16.2785 13.7129C16.2782 13.7137 16.2773 13.7172 16.2712 13.7257C16.2547 13.7487 16.2119 13.7927 16.0976 13.8699L16.0976 13.8699L16.0955 13.8714C16.0911 13.8744 16.0865 13.8776 16.0816 13.8809C15.8554 14.0359 15.1742 14.5029 15.1742 15.4399V15.5799C15.1742 16.0331 15.5468 16.4057 16 16.4057C16.4533 16.4057 16.8258 16.0331 16.8258 15.5799V15.4399C16.8258 15.4166 16.8283 15.4063 16.8293 15.4029C16.83 15.4005 16.8313 15.3964 16.8375 15.3879C16.8545 15.3641 16.8988 15.319 17.0208 15.2376ZM15.1742 17.2332C15.1742 17.6836 15.5373 18.059 16 18.059C16.4628 18.059 16.8258 17.6836 16.8258 17.2332C16.8258 16.7828 16.4628 16.4074 16 16.4074C15.5373 16.4074 15.1742 16.7828 15.1742 17.2332Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.651602
});

var SvgWarningIcon = function SvgWarningIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWarningIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WarningIcon.2e5506ba.svg";
export { ForwardRef as ReactComponent };